var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","height":"80px","line-height":"80px"}},[_vm._v(" 商城固定头部 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }